var $cont = document.querySelector('.cont');
var $context = document.querySelector('.context');
var $elsArr = [].slice.call(document.querySelectorAll('.el'));
var $closeBtnsArr = [].slice.call(document.querySelectorAll('.el__close-btn'));

// 检测是否为移动端
function isMobile() {
  return window.innerWidth <= 1023;
}

// 移动端swiper实例
var mobileSwiper = null;

console.log('elsArr', $elsArr);
console.log('closeBtnsArr', $closeBtnsArr);

setTimeout(function () {
  $cont.classList.remove('s--inactive');
  
  // 移动端初始化swiper
  if (isMobile()) {
    initMobileSwiper();
  }
}, 200);

// 初始化移动端swiper
function initMobileSwiper() {
  var swiperContainer = document.querySelector('.mobile-swiper');
  if (swiperContainer && typeof Swiper !== 'undefined') {
    mobileSwiper = new Swiper('.mobile-swiper', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      on: {
        slideChange: function () {
          console.log('slide changed to:', this.activeIndex);
        }
      }
    });
  }
}

// 桌面端卡片点击事件
$elsArr.forEach(function ($el, index) {
  $el.addEventListener('click', function () {
    if (this.classList.contains('s--active')) return;
    
    $cont.classList.add('s--el-active');
    $cont.style.padding = '0';
    this.classList.add('s--active');
    $context.classList.add('context--active');
  });
});

// 桌面端关闭按钮事件
$closeBtnsArr.forEach(function ($btn) {
  $btn.addEventListener('click', function (e) {
    e.stopPropagation();
    
    $cont.style.padding = '16px';
    document.querySelector('.el.s--active').classList.remove('s--active');
    $cont.classList.remove('s--el-active');
    $context.classList.remove('context--active');
  });
});

// 监听窗口大小变化，处理响应式
window.addEventListener('resize', function() {
  // 如果从桌面端切换到移动端，需要初始化swiper
  if (isMobile() && !mobileSwiper) {
    initMobileSwiper();
  }
  // 如果从移动端切换到桌面端，需要销毁swiper
  else if (!isMobile() && mobileSwiper) {
    mobileSwiper.destroy(true, true);
    mobileSwiper = null;
  }
});